import CardLink from '../components/CardLink';

// Parse text and replace [[Card Name]] with CardLink components
export function parseCardLinks(text, isUserMessage = false) {
  const parts = [];
  let lastIndex = 0;
  
  // Regex to find [[Card Name]] patterns
  const regex = /\[\[([^\]]+)\]\]/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Add the CardLink component
    const cardName = match[1];
    parts.push(
      <CardLink
        key={`${cardName}-${match.index}`}
        cardName={cardName}
        isUserMessage={isUserMessage} />
    );
    
    lastIndex = match.index + match[0].length;
  }
  
  // Add remaining text
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  return parts.length > 0 ? parts : text;
}